export const translations = {
  en: {
    // Auth Page
    login: "Login",
    signUp: "Sign Up",
    name: "Name",
    email: "Email",
    password: "Password",
    language: "Language",
    createAccount: "Create Account",
    continueWithGoogle: "Continue with Google",
    or: "or",
    tagline: "Create magical personalized stories for children",
    
    // Cookie Banner
    cookie_banner_title: "We Value Your Privacy",
    cookie_banner_description: "We use cookies to ensure you get the best experience on our website. Some are essential for the site to function, while others help us personalize your experience and analyze usage.",
    cookie_accept_all: "Accept All",
    cookie_reject_all: "Reject All",
    cookie_customize: "Customize",
    cookie_settings_title: "Cookie Settings",
    cookie_settings_intro: "Manage your cookie preferences below. Essential cookies cannot be disabled as they are necessary for the website to function properly.",
    cookie_necessary_title: "Strictly Necessary Cookies",
    cookie_necessary_description: "These cookies are essential for the website to function. They enable core functionality such as security, authentication, and accessibility.",
    cookie_functional_title: "Functional Cookies",
    cookie_functional_description: "These cookies enable enhanced functionality and personalization, such as language preferences and user settings.",
    cookie_analytics_title: "Analytics Cookies",
    cookie_analytics_description: "These cookies help us understand how visitors interact with our website, allowing us to improve the user experience.",
    cookie_marketing_title: "Marketing Cookies",
    cookie_marketing_description: "These cookies are used to track visitors across websites to display relevant advertisements and marketing campaigns.",
    cookie_always_active: "Always Active",
    cookie_save_preferences: "Save Preferences",
    cookie_cancel: "Cancel",
    
    // Dashboard
    welcomeBack: "Welcome back",
    createNewStory: "Create New Story",
    dailyLimitReached: "Daily limit reached. Next story in",
    searchStories: "Search stories by title, child name, or theme...",
    noStoriesYet: "No stories yet",
    createFirstStory: "Create your first magical story!",
    forAge: "For",
    yearsOld: "years old",
    read: "Read",
    delete: "Delete",
    settings: "Settings",
    contact: "Contact",
    logout: "Logout",
    
    // Create Story
    createMagicalStory: "Create a Magical Story",
    personalizedForChild: "Personalized just for your child",
    childName: "Child's Name",
    enterChildName: "Enter child's name",
    age: "Age",
    selectAge: "Select age",
    storyTheme: "Story Theme",
    chooseTheme: "Choose a theme",
    customTheme: "Custom Theme",
    describeCustomTheme: "Describe your custom theme",
    avoidViolence: "Please avoid themes with violence, fear, or inappropriate content",
    createStory: "Create Story",
    creatingStory: "Creating your magical story...",
    craftingStory: "Crafting your personalized story...",
    writingAdventure: "Writing",
    adventure: "'s adventure...",
    creatingIllustrations: "Creating beautiful illustrations...",
    mayTakeMinutes: "This may take 1-2 minutes",
    
    // Story Reader
    backToLibrary: "Back to Library",
    exportPDF: "Export PDF",
    print: "Print",
    sendToKindle: "Send to Kindle",
    specialStoryFor: "A special story for",
    page: "Page",
    of: "of",
    previous: "Previous",
    next: "Next",
    
    // Settings
    profile: "Profile",
    updateProfile: "Update Profile",
    sendToKindleSettings: "Send to Kindle",
    kindleEmailAddress: "Kindle Email Address",
    kindleEmailPlaceholder: "username@kindle.com",
    approveInKindle: "Note: You'll need to approve the sender email in your Amazon Kindle settings",
    updateKindleEmail: "Update Kindle Email",
    dangerZone: "Danger Zone",
    deleteAccountWarning: "Once you delete your account, there is no going back. All your stories will be permanently deleted.",
    deleteAccount: "Delete Account",
    
    // Contact
    contactUs: "Contact Us",
    feedbackTagline: "We'd love to hear your feedback and suggestions!",
    yourEmail: "Your Email",
    yourMessage: "Your Message",
    messagePlaceholder: "Share your feedback, suggestions, or report any issues...",
    sendFeedback: "Send Feedback",
    sending: "Sending...",
    dashboard: "Dashboard",
    
    // Story Themes
    themes: {
      bedtime: "Bedtime calm adventure",
      animals: "Animal friends at the park",
      space: "Space explorer journey",
      fairy: "Fairy forest mystery (gentle)",
      dinosaurs: "Friendly dinosaurs at school",
      ocean: "Ocean treasure discovery",
      pirate: "Pirate picnic (cozy, non-violent)",
      superhero: "Super-helper day (kindness missions)",
      timetravel: "Time-travel to grandma's childhood",
      robot: "Robot learns emotions",
      custom: "Custom theme"
    },
    
    // Blog
    blog: "Blog",
    blogTitle: "Our Blog",
    blogSubtitle: "Latest news, tips, and stories",
    readMore: "Read more",
    backToBlog: "Back to Blog",
    comments: "Comments",
    addComment: "Add a comment",
    postComment: "Post Comment",
    noComments: "No comments yet. Be the first to comment!",
    writingComment: "Write your comment...",
    adminBlogManagement: "Blog Management",
    createNewPost: "Create New Post",
    editPost: "Edit Post",
    deletePost: "Delete Post",
    postTitle: "Post Title",
    postContent: "Post Content",
    featuredImage: "Featured Image URL",
    publishPost: "Publish Post",
    saveDraft: "Save Draft",
    published: "Published",
    draft: "Draft",
    noBlogPosts: "No blog posts yet",
    createFirstPost: "Create your first blog post!",
    
    // Toast Messages
    toasts: {
      welcomeToPro: "🎉 Welcome to Pro! Your subscription is now active.",
      paymentVerificationFailed: "Failed to verify payment. Please contact support if you completed the payment.",
      paymentVerificationDelay: "Payment verification taking longer than expected. Please refresh the page.",
      failedToLoadStories: "Failed to load stories",
      storyDeleted: "Story deleted",
      failedToDeleteStory: "Failed to delete story",
      weeklyLimitReached: "Weekly story limit reached",
      pleaseSelectTheme: "Please select or enter a theme",
      storyCreatedSuccess: "Story created successfully!",
      storyCreatingBackground: "✨ Your story is being created! You can navigate away - it will appear in your dashboard when ready (1-2 minutes).",
      generatingTitle: "Creating Story for {child_name}...",
      failedToCreateStory: "Failed to create story",
      failedCheckoutSession: "Failed to create checkout session",
      subscriptionCancelled: "Subscription cancelled successfully",
      failedToCancelSubscription: "Failed to cancel subscription",
      profileUpdated: "Profile updated successfully",
      failedToUpdateProfile: "Failed to update profile",
      kindleEmailUpdated: "Kindle email updated successfully",
      failedToUpdateKindleEmail: "Failed to update Kindle email",
      accountDeleted: "Account deleted successfully",
      failedToDeleteAccount: "Failed to delete account",
      failedToLoadStory: "Failed to load story",
      pdfDownloaded: "PDF downloaded!",
      failedToExportPdf: "Failed to export PDF",
      failedToSendKindle: "Failed to send to Kindle",
      printNotAvailable: "Print functionality not available in this browser",
      failedToPrint: "Failed to open print dialog",
      enterFeedback: "Please enter your feedback",
      feedbackSentSuccess: "Feedback sent successfully! Thank you!",
      failedToSendFeedback: "Failed to send feedback",
      welcomeBack: "Welcome back!",
      accountCreated: "Account created!",
      authenticationFailed: "Authentication failed"
    }
  },
  de: {
    // Auth Page
    login: "Anmelden",
    signUp: "Registrieren",
    name: "Name",
    email: "E-Mail",
    password: "Passwort",
    language: "Sprache",
    createAccount: "Konto erstellen",
    continueWithGoogle: "Mit Google fortfahren",
    or: "oder",
    tagline: "Erstelle magische personalisierte Geschichten für Kinder",
    
    // Cookie Banner
    cookie_banner_title: "Wir schätzen Ihre Privatsphäre",
    cookie_banner_description: "Wir verwenden Cookies, um Ihnen die beste Erfahrung auf unserer Website zu bieten. Einige sind für die Funktion der Website unerlässlich, während andere uns helfen, Ihre Erfahrung zu personalisieren und die Nutzung zu analysieren.",
    cookie_accept_all: "Alle akzeptieren",
    cookie_reject_all: "Alle ablehnen",
    cookie_customize: "Anpassen",
    cookie_settings_title: "Cookie-Einstellungen",
    cookie_settings_intro: "Verwalten Sie Ihre Cookie-Präferenzen unten. Essentielle Cookies können nicht deaktiviert werden, da sie für das ordnungsgemäße Funktionieren der Website erforderlich sind.",
    cookie_necessary_title: "Unbedingt notwendige Cookies",
    cookie_necessary_description: "Diese Cookies sind für das Funktionieren der Website unerlässlich. Sie ermöglichen Kernfunktionen wie Sicherheit, Authentifizierung und Barrierefreiheit.",
    cookie_functional_title: "Funktionale Cookies",
    cookie_functional_description: "Diese Cookies ermöglichen erweiterte Funktionen und Personalisierung, wie Spracheinstellungen und Benutzereinstellungen.",
    cookie_analytics_title: "Analyse-Cookies",
    cookie_analytics_description: "Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, damit wir die Benutzererfahrung verbessern können.",
    cookie_marketing_title: "Marketing-Cookies",
    cookie_marketing_description: "Diese Cookies werden verwendet, um Besucher über Websites hinweg zu verfolgen, um relevante Werbung und Marketingkampagnen anzuzeigen.",
    cookie_always_active: "Immer aktiv",
    cookie_save_preferences: "Einstellungen speichern",
    cookie_cancel: "Abbrechen",
    
    // Dashboard
    welcomeBack: "Willkommen zurück",
    createNewStory: "Neue Geschichte erstellen",
    dailyLimitReached: "Tageslimit erreicht. Nächste Geschichte in",
    searchStories: "Suche Geschichten nach Titel, Kindername oder Thema...",
    noStoriesYet: "Noch keine Geschichten",
    createFirstStory: "Erstelle deine erste magische Geschichte!",
    forAge: "Für",
    yearsOld: "Jahre alt",
    read: "Lesen",
    delete: "Löschen",
    settings: "Einstellungen",
    contact: "Kontakt",
    logout: "Abmelden",
    
    // Create Story
    createMagicalStory: "Erstelle eine magische Geschichte",
    personalizedForChild: "Personalisiert für dein Kind",
    childName: "Name des Kindes",
    enterChildName: "Name eingeben",
    age: "Alter",
    selectAge: "Alter wählen",
    storyTheme: "Geschichte Thema",
    chooseTheme: "Thema wählen",
    customTheme: "Eigenes Thema",
    describeCustomTheme: "Beschreibe dein eigenes Thema",
    avoidViolence: "Bitte vermeide Themen mit Gewalt, Angst oder unangemessenen Inhalten",
    createStory: "Geschichte erstellen",
    creatingStory: "Erstelle deine magische Geschichte...",
    craftingStory: "Deine personalisierte Geschichte wird erstellt...",
    writingAdventure: "",
    adventure: "s Abenteuer wird geschrieben...",
    creatingIllustrations: "Wunderschöne Illustrationen werden erstellt...",
    mayTakeMinutes: "Dies kann 1-2 Minuten dauern",
    
    // Story Reader
    backToLibrary: "Zurück zur Bibliothek",
    exportPDF: "PDF exportieren",
    print: "Drucken",
    sendToKindle: "An Kindle senden",
    specialStoryFor: "Eine besondere Geschichte für",
    page: "Seite",
    of: "von",
    previous: "Zurück",
    next: "Weiter",
    
    // Settings
    profile: "Profil",
    updateProfile: "Profil aktualisieren",
    sendToKindleSettings: "An Kindle senden",
    kindleEmailAddress: "Kindle E-Mail-Adresse",
    kindleEmailPlaceholder: "benutzername@kindle.com",
    approveInKindle: "Hinweis: Sie müssen die Absender-E-Mail in Ihren Amazon Kindle-Einstellungen genehmigen",
    updateKindleEmail: "Kindle E-Mail aktualisieren",
    dangerZone: "Gefahrenzone",
    deleteAccountWarning: "Sobald Sie Ihr Konto löschen, gibt es kein Zurück mehr. Alle Ihre Geschichten werden dauerhaft gelöscht.",
    deleteAccount: "Konto löschen",
    
    // Contact
    contactUs: "Kontaktiere uns",
    feedbackTagline: "Wir freuen uns über dein Feedback und deine Vorschläge!",
    yourEmail: "Deine E-Mail",
    yourMessage: "Deine Nachricht",
    messagePlaceholder: "Teile dein Feedback, Vorschläge oder melde Probleme...",
    sendFeedback: "Feedback senden",
    sending: "Wird gesendet...",
    dashboard: "Dashboard",
    
    // Story Themes
    themes: {
      bedtime: "Ruhiges Schlafabenteuer",
      animals: "Tierfreunde im Park",
      space: "Weltraumforscher-Reise",
      fairy: "Feenwald-Geheimnis (sanft)",
      dinosaurs: "Freundliche Dinosaurier in der Schule",
      ocean: "Schatzsuche im Ozean",
      pirate: "Piraten-Picknick (gemütlich, gewaltfrei)",
      superhero: "Super-Helfer Tag (Freundlichkeitsmissionen)",
      timetravel: "Zeitreise zu Omas Kindheit",
      robot: "Roboter lernt Gefühle",
      custom: "Eigenes Thema"
    },
    
    // Blog
    blog: "Blog",
    blogTitle: "Unser Blog",
    blogSubtitle: "Neueste Nachrichten, Tipps und Geschichten",
    readMore: "Weiterlesen",
    backToBlog: "Zurück zum Blog",
    comments: "Kommentare",
    addComment: "Kommentar hinzufügen",
    postComment: "Kommentar posten",
    noComments: "Noch keine Kommentare. Sei der Erste, der kommentiert!",
    writingComment: "Schreibe deinen Kommentar...",
    adminBlogManagement: "Blog-Verwaltung",
    createNewPost: "Neuen Beitrag erstellen",
    editPost: "Beitrag bearbeiten",
    deletePost: "Beitrag löschen",
    postTitle: "Beitragstitel",
    postContent: "Beitragsinhalt",
    featuredImage: "Titelbild URL",
    publishPost: "Beitrag veröffentlichen",
    saveDraft: "Entwurf speichern",
    published: "Veröffentlicht",
    draft: "Entwurf",
    noBlogPosts: "Noch keine Blog-Beiträge",
    createFirstPost: "Erstelle deinen ersten Blog-Beitrag!",
    
    // Toast Messages
    toasts: {
      welcomeToPro: "🎉 Willkommen bei Pro! Dein Abonnement ist jetzt aktiv.",
      paymentVerificationFailed: "Zahlungsbestätigung fehlgeschlagen. Bitte kontaktiere den Support, falls du die Zahlung abgeschlossen hast.",
      paymentVerificationDelay: "Zahlungsbestätigung dauert länger als erwartet. Bitte aktualisiere die Seite.",
      failedToLoadStories: "Geschichten konnten nicht geladen werden",
      storyDeleted: "Geschichte gelöscht",
      failedToDeleteStory: "Geschichte konnte nicht gelöscht werden",
      weeklyLimitReached: "Wöchentliches Limit erreicht",
      pleaseSelectTheme: "Bitte wähle ein Thema aus oder gib eines ein",
      storyCreatedSuccess: "Geschichte erfolgreich erstellt!",
      storyCreatingBackground: "✨ Deine Geschichte wird erstellt! Du kannst navigieren - sie erscheint in deinem Dashboard wenn fertig (1-2 Minuten).",
      generatingTitle: "Geschichte für {child_name} wird erstellt...",
      failedToCreateStory: "Geschichte konnte nicht erstellt werden",
      failedCheckoutSession: "Checkout-Sitzung konnte nicht erstellt werden",
      subscriptionCancelled: "Abonnement erfolgreich gekündigt",
      failedToCancelSubscription: "Abonnement konnte nicht gekündigt werden",
      profileUpdated: "Profil erfolgreich aktualisiert",
      failedToUpdateProfile: "Profil konnte nicht aktualisiert werden",
      kindleEmailUpdated: "Kindle E-Mail erfolgreich aktualisiert",
      failedToUpdateKindleEmail: "Kindle E-Mail konnte nicht aktualisiert werden",
      accountDeleted: "Konto erfolgreich gelöscht",
      failedToDeleteAccount: "Konto konnte nicht gelöscht werden",
      failedToLoadStory: "Geschichte konnte nicht geladen werden",
      pdfDownloaded: "PDF heruntergeladen!",
      failedToExportPdf: "PDF-Export fehlgeschlagen",
      failedToSendKindle: "Senden an Kindle fehlgeschlagen",
      printNotAvailable: "Druckfunktion in diesem Browser nicht verfügbar",
      failedToPrint: "Druckdialog konnte nicht geöffnet werden",
      enterFeedback: "Bitte gib dein Feedback ein",
      feedbackSentSuccess: "Feedback erfolgreich gesendet! Vielen Dank!",
      failedToSendFeedback: "Feedback konnte nicht gesendet werden",
      welcomeBack: "Willkommen zurück!",
      accountCreated: "Konto erstellt!",
      authenticationFailed: "Authentifizierung fehlgeschlagen"
    }
  }
};

export const getTranslation = (lang, key, variables = {}) => {
  const keys = key.split('.');
  let value = translations[lang] || translations['en'];
  
  for (const k of keys) {
    value = value[k];
    if (!value) return key;
  }
  
  // Replace variables in the format {variable_name}
  if (typeof value === 'string' && Object.keys(variables).length > 0) {
    Object.keys(variables).forEach(varKey => {
      value = value.replace(`{${varKey}}`, variables[varKey]);
    });
  }
  
  return value;
};
